interface TCacheData<T = any>
{
	record: T;
	create_dt: Date;
	expire_dt: Date;
}

export class RecordCache<T = any>
{
	cache: TCacheData[] = [];

	/** Find a record that matches based on the properties passed into the props values
	Notes: this function returns an array to be compatible with the DataQuery search
	function but returns only the 1st valid match.
	*/
	find(props: any): T[]
	{
		const now = new Date().getTime();
		let results: T[] = [];

		// console.log("CACHE Find:", props, " in  ",this.cache.length);

		for (const obj of this.cache)
		{
			// skip expired records.
			if (obj.expire_dt.getTime() < now) continue;

			let isMatch: boolean = true;
			for (let propName of Object.keys(props))
			{
				if ((obj as any).record.data)
				{
					// console.log("Check 1:", props[propName], " vs ", (obj.record as any).data[propName]);
					if (props[propName] !== (obj.record as any).data[propName]) isMatch = false;
				} else
				{
					// console.log("Check 2:", props[propName], " vs ", (obj.record as any).data[propName]);
					if (props[propName] !== (obj.record as any)[propName]) isMatch = false;
				}
			}

			if (isMatch)
			{
				// It's an array of matches but we only want a single returned
				results.push(obj.record);
				return results;
			} else
			{
			}
		}

		// console.log("Cache no match for ", props);
		return results;
	}

	/** Add a record to the cache */
	add(record: T, expire_seconds: number)
	{
		this.cache.push({
			record: record,
			create_dt: new Date(),
			expire_dt: new Date(new Date().getTime() + (expire_seconds * 1000))
		});

		// TODO:  Add better cache cleanup than this.
		if (this.cache.length > 200)
			this.cache = [];
	}

}
